import useApi from '../useApi'
import type { ApiResponse } from '../useApi'
import { UPLOAD_ATTACHMENTS_TYPES } from 'common'

type Params = {
  attachmentType: ValueOf<typeof UPLOAD_ATTACHMENTS_TYPES>
}

export type GetUrlHandler = (params: { key: string }) => Promise<void | ApiResponse<string>>

const useGetUrl = ({ attachmentType }: Params): { getUrlHandler: GetUrlHandler } => {
  const { handleApi } = useApi({ method: 'GET', url: '/attachments/presigned', autoExecute: false })

  const getUrlHandler: GetUrlHandler = async ({ key }) => {
    const { response: url, isError } = await handleApi<string>({
      params: {
        attachmentType,
        key
      }
    })

    if (isError) return

    return url
  }

  return { getUrlHandler }
}

export { useGetUrl }
